<form [formGroup]="androidBuildForm" id="androidBuildWrapper" class="page-wrapper" (ngSubmit)="onSubmit()">

  <!-- Form Fields Card (shown when not building or when done/error) -->
  <div class="card" *ngIf="(!buildStart || value == 100 || error) && !checkingStatus">
    <div class="card-title">{{ 'Android APK' | translate }}</div>
    <div class="card-divider"></div>

    <div class="fields-row">
      <!-- Android Version -->
      <div class="field-group">
        <label class="field-label" for="androidVersion">{{ 'Android Version' | translate }}</label>
        <input
          class="field-input"
          id="androidVersion"
          placeholder="0"
          type="number"
          min="0.1"
          step="0.1"
          max="9999"
          formControlName="androidVersion"
        />
        <span class="field-hint">{{ 'Format example: 1.0 or 1.1' | translate }}</span>
      </div>

      <!-- Android Version Code -->
      <div class="field-group">
        <label class="field-label" for="androidVersionCode">{{ 'Android Version Code' | translate }}</label>
        <input
          class="field-input"
          id="androidVersionCode"
          placeholder="0"
          type="number"
          min="1"
          step="1"
          max="999999"
          formControlName="androidVersionCode"
          (input)="onInput($event)"
        />
        <span class="field-hint">{{ 'Integer value (e.g. 1, 2, 3)' | translate }}</span>
      </div>
    </div>

    <!-- Auth0 Note -->
    <div class="note-banner" *ngIf="noteMessage">
      <span class="material-icons-outlined note-icon">info</span>
      <p class="note-text">{{ noteMessage | translate }}</p>
    </div>
  </div>

  <!-- Checking Status -->
  <div class="card status-card" *ngIf="checkingStatus && !error">
    <div class="gradient-spinner"></div>
    <p class="status-text">{{ 'Checking Build Status' | translate }}</p>
  </div>

  <!-- Building In Progress -->
  <div class="card status-card" *ngIf="buildStart && !checkingStatus && !error && value < 100">
    <div class="progress-circle-wrap">
      <svg class="progress-circle" viewBox="0 0 80 80">
        <defs>
          <linearGradient id="apkProgressGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#4FF28B"/>
            <stop offset="100%" stop-color="#19789A"/>
          </linearGradient>
        </defs>
        <circle class="progress-track" cx="40" cy="40" r="34"/>
        <circle
          class="progress-fill"
          cx="40" cy="40" r="34"
          [style.stroke-dashoffset]="213.6 - (213.6 * value / 100)"
        />
      </svg>
      <span class="progress-label">{{ value }}%</span>
    </div>
    <button class="btn-generate generating" type="button" disabled>
      <span class="material-icons-outlined">auto_fix_high</span>
      {{ 'Generating Android APK...' | translate }}
    </button>
    <p class="dont-close">{{ "please don't close this window" | translate }}</p>
  </div>

  <!-- Success State -->
  <div class="card success-card" *ngIf="value == 100 && buildStart && !checkingStatus && !error">
    <div class="success-left">
      <div class="success-top">
        <img src="assets/icons/rightCheck.svg" [alt]="'right circle' | translate">
        <p class="success-title">{{ 'Finish Generating' | translate }}</p>
        <p class="success-sub">{{ 'Your Android App Generated Successfully.' | translate }}</p>
      </div>
      <div class="success-actions">
        <a
          *ngIf="playType == 'apk'"
          href="{{ downloadBtn }}"
          class="btn-download"
        >
          <img src="assets/icons/downloadIcon.svg" alt="download">
          {{ 'Download Android APK' | translate }}
        </a>
        <a
          *ngIf="playType == 'apk'"
          class="btn-preview"
          [href]="environment.stacksAppPreviewURL + '?project_id=' + builderService.selectedProject"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span class="material-icons-outlined">visibility</span>
          {{ 'Preview App' | translate }}
        </a>
      </div>
    </div>
    <div class="success-right" *ngIf="qrLink && ((!this.builderService.standalone && this.builderService.selectedProjectDomain) || this.builderService.standalone)">
      <img [src]="qrLink" [alt]="'QR Code' | translate" class="qr-image" />
      <p class="qr-label">{{ 'you can download directly' | translate }}<br/>{{ 'from scan this QR Code' | translate }}</p>
    </div>
  </div>

  <!-- Error State -->
  <div class="card error-card" *ngIf="error">
    <span class="material-icons-outlined error-icon">error_outline</span>
    <p class="error-msg" *ngIf="buildErrorMsg && buildErrorMsg !== ''">{{ buildErrorMsg }}</p>
    <p class="error-msg" *ngIf="!buildErrorMsg || buildErrorMsg === ''">
      {{ 'Error occured while building' | translate }}<br/>
      {{ 'please try again' | translate }}<br/>
      {{ 'If the error persists then contact the customer support' | translate }}
    </p>
    <button type="button" class="btn-rebuild" (click)="rebuildApp()">
      {{ 'Rebuild App' | translate }}
    </button>
  </div>

  <!-- Generate Button (shown at form stage only) -->
  <div *ngIf="(!buildStart || value == 100 || error) && !checkingStatus" class="generate-btn-wrap">
    <button
      class="btn-generate"
      type="submit"
      [disabled]="androidBuildForm.invalid"
    >
      <span class="material-icons-outlined">auto_fix_high</span>
      {{ 'Generate Android APK' | translate }}
    </button>
  </div>

</form>
